import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';
import * as lessonSelectors from 'common.components/lesson/selectors';

import { ACTION_BUTTON_MODE } from './action-button-mode';
import * as selectors from './selectors';
import AssignLessonButton from './_assign-lesson/side-panel__action-button_assign-lesson';
import DeleteLessonButton from './side-panel__action-button_delete';
import { EditAssignmentButton } from './side-panel__action-button_edit-assignment';
import ForceCompleteLessonButton from './side-panel__action-button_force-complete';
import { LessonAssignmentDisabledButton } from './side-panel__action-button_lesson-assignment-disabled';
import LessonCompletedButton from './side-panel__action-button_lesson-completed';

import './side-panel__action-button.scss';

interface OwnProps extends WithRouterPathProps {
    onForceComplete?: () => void;
}

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends OwnProps, StoreProps {}

// eslint-disable-next-line complexity
export const ActionButton = (props: Props) => {
    const { mode, onForceComplete } = props;

    switch (mode) {
        case ACTION_BUTTON_MODE.ASSIGN_LESSON:
        case ACTION_BUTTON_MODE.SAVE_ASSIGNMENT:
        case ACTION_BUTTON_MODE.REASSIGN_LESSON:
        case ACTION_BUTTON_MODE.ASSIGN_IN_EXTERNAL_LMS:
            //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: потерян io
            return <AssignLessonButton />;
        case ACTION_BUTTON_MODE.EDIT_ASSIGNMENT:
            return <EditAssignmentButton />;
        case ACTION_BUTTON_MODE.FORCE_COMPLETE_LESSON:
            //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: потерян io
            return <ForceCompleteLessonButton onForceComplete={onForceComplete} />;
        case ACTION_BUTTON_MODE.LESSON_COMPLETED:
            return <LessonCompletedButton />;
        case ACTION_BUTTON_MODE.ASSIGNMENT_DISABLED:
            return <LessonAssignmentDisabledButton />;
        case ACTION_BUTTON_MODE.DELETE_LESSON:
            return <DeleteLessonButton />;
        default:
            return null;
    }
};

const mapStateToProps = (storeState: any, ownProps: OwnProps) => {
    const {
        location: { search },
    } = ownProps;
    const clesson = lessonSelectors.getLesson(storeState)!;
    const courseId = getCurrentYearCourseId(storeState);
    const clessonId = clesson?.id || null;

    return {
        mode: selectors.getActionButtonMode(storeState, { courseId, lessonId: clessonId, search }),
    };
};

export default withRouterPath(connect(mapStateToProps)(ActionButton));
